import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { required } from '../../utils/validations'
import BasicForm from '../forms/BasicForm'

export default class ValidateRecoveryCode extends Component {
  render() {
    return (
      <BasicForm
        fields={ this.fields() }
        onSubmit={ this.onSubmit }
      />
    )
  }

  fields = () => {
    return [{
      name: 'code',
      placeholder: 'Recovery Code Sent To Email',
      type: 'text',
      validations: [required]
    }]
  }

  onSubmit = (formValues) => {
    this.props.onSubmit(formValues)
  }
}

ValidateRecoveryCode.propTypes = {
  onSubmit: PropTypes.func.isRequired
}
